import countries from '../../data/countries.json'

function emptyDate(value, originalValue) {
  if (
    typeof originalValue === "string" &&
    (originalValue === "" || originalValue === "Invalid Date")
  ) {
    return "";
  }
  return originalValue.split("T")[0];
}

function emptyStringToNull(value, originalValue) {
  if (typeof originalValue === "string" && originalValue === "") {
    return null;
  }
  return Number(value);
}

const fields = [
  {
    name: "employeeName",
    type: "text",
    label: "Name",
    validationType: "string",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },

  {
    name: "notes",
    type: "text",
    label: "Notes",
    validationType: "string",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },

  {
    name: "absenceFrom",
    type: "text",
    label: "Absence From",
    validationType: "string",
    validations: [
      {
        type: "date",
        params: ["this field is required"],
      },
    ],
  },
  {
    name: "absenceTo",
    type: "text",
    label: "Absence To",
    validationType: "string",
    validations: [
      {
        type: "date",
        params: ["this field is required"],
      },
    ],
  },

 
];

export default fields;
